import React, { useEffect, useState } from "react";
import axios from "axios";
import MainHeader from "./MainHeader";
import Sidebar from "./Sidebar";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import FullPageLoader from "./FullPageLoader";
import { LuArchiveRestore, LuDatabaseBackup } from "react-icons/lu";
import { FaDatabase } from "react-icons/fa";

const DBbackup = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [selectedDatabases, setSelectedDatabases] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [serverData, setServerData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isBackingUp, setIsBackingUp] = useState(false);
  const [blobs, setBlobs] = useState([]);
  const [isBlobsLoading, setIsBlobsLoading] = useState(false);
  const [selectedBlob, setSelectedBlob] = useState(null); // stores clicked blob
  const [selectedServer, setSelectedServer] = useState(null); // single server selection
  const [showCheckboxes, setShowCheckboxes] = useState(false);
  const [showDbModal, setShowDbModal] = useState(false);
  const [selectedDatabase, setSelectedDatabase] = useState("");
  const [selectedDbIds, setSelectedDbIds] = useState([]);

  const DB_LIST_API_URL = "https://devwebsocket.drtestdash.com/dbServers/database";
  const DB_BLOB_API_URL = "https://devwebsocket.drtestdash.com/dbServers/list-blobs";
  const DB_BACKUP_MSSQL_API_URL =
    "https://devwebsocket.drtestdash.com/dbServers/backup";
  const DB_BACKUP_MYSQL_API_URL =
    "https://devwebsocket.drtestdash.com/dbServers/mySqlBackup";
  const DB_RESTORE_API_URL = "https://devwebsocket.drtestdash.com/dbServers/restore";

  const fetchDbServers = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(DB_LIST_API_URL);
      console.log(response.data, "API Response");
      setServerData(response?.data?.data);
    } catch (err) {
      console.error(err.message || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const fetchBlobs = async () => {
    try {
      setIsBlobsLoading(true);
      const response = await axios.get(DB_BLOB_API_URL);
      setBlobs(response.data?.blobs || []);
    } catch (error) {
      console.error("Failed to fetch blobs", error);
    } finally {
      setIsBlobsLoading(false);
    }
  };

  useEffect(() => {
    fetchDbServers();
    fetchBlobs();
  }, []);

  const handleSidebarToggle = (isOpen) => {
    setIsSidebarOpen(isOpen);
  };
  const handlePreview = (databases, resourceGroup, serverName, serverType) => {
    const enrichedDatabases = databases.map((db) => ({
      ...db,
      resourceGroup,
      serverName,
      serverType,
    }));
    console.log(enrichedDatabases, "Enriched Databases");

    setSelectedDatabases(enrichedDatabases);
    setShowModal(true);
  };

  const toggleDbSelection = (dbName) => {
    setSelectedDbIds((prev) =>
      prev.includes(dbName)
        ? prev.filter((name) => name !== dbName)
        : [...prev, dbName]
    );
  };

  const handleBulkBackup = async (selectedDbs) => {
    if (!selectedDbs.length) return;

    setIsBackingUp(true);

    try {
      // Group databases by resourceGroup, serverName, and serverType using reduce
      const grouped = selectedDbs.reduce((acc, db) => {
        const key = `${db.resourceGroup}||${db.serverName}||${db.serverType}`;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(db.name);
        console.log(acc, "accumulator");
        return acc;
      }, {});

      // Send one request per group with databaseNames array
      const backupPromises = Object.entries(grouped).map(
        async ([key, databaseName]) => {
          let [resourceGroup, serverName, serverType] = key.split("||");

          if (serverType === "MySQL Server") {
            serverName = `${serverName}.mysql.database.azure.com`;
          }

          const payload = {
            resourceGroup,
            serverName,
            databaseName, // array of names
          };

          const backupURL =
            serverType === "SQL Server"
              ? DB_BACKUP_MSSQL_API_URL
              : DB_BACKUP_MYSQL_API_URL;

          try {
            const response = await axios.post(backupURL, payload);
            toast.success(`Backed up: ${databaseName.join(", ")}`);
            console.log("Backup response:", response.data);
          } catch (error) {
            const errorMsg =
              error.response?.data?.error || "Bulk backup failed";      
            toast.error(`${errorMsg}: ${databaseName.join(", ")}`);
            console.error("Bulk backup error:", error);
          }
        }
      );

      await Promise.all(backupPromises);
      setSelectedDbIds([]);
      fetchBlobs();
      setShowModal(false);
    } finally {
      setIsBackingUp(false);
    }
  };

  const handleRestore = async () => {
    setIsBackingUp(true);
    if (!selectedDatabase || !selectedBlob || !selectedServer) {
      alert("Please select server, database and blob file");
      return;
    }

    const payload = {
      resourceGroup: selectedServer.resourceGroup,
      serverName: selectedServer.serverName,
      databaseName: selectedDatabase,
      blobFileName: selectedBlob,
    };

    try {
      await axios.post(DB_RESTORE_API_URL, payload);
      toast.success("Restore Completed!");
      setShowDbModal(false);
    } catch (err) {
      console.error("Restore failed:", err);
      alert("Restore failed.");
    } finally {
      setIsBackingUp(false); // Hide loader
    }
  };

  return (
    <>
      <Sidebar onToggle={handleSidebarToggle} />
      <div
        className={`content p-5 ${
          isSidebarOpen ? "content-expanded" : "content-collapsed"
        }`}
      >
        <MainHeader></MainHeader>

        <div className="ps-4 mt-4">
          <div className="main-panel">
            <div className="d-flex gap-3">
              <div className="w-70">
                <div className="card rounded">
                  <div className="card-header text-uppercase fw-bold">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>All SQL Servers</div>
                      <div>
                        {showCheckboxes && selectedServer && (
                          <button
                            type="button"
                            className="btn btn-light"
                            onClick={() => setShowDbModal(true)}
                          >
                            Select DB <FaDatabase />
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="card-body dashboard p-3">
                    {isLoading ? (
                      <div className="d-flex justify-content-center my-4">
                        <div className="spinner-border" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <div className="table-responsive">
                        <table className="table table-alter">
                          <thead className="tablebg">
                            <tr>
                              {showCheckboxes && (
                                <th className="text-uppercase tablebgtext border-top border-bottom text-center">
                                  Select
                                </th>
                              )}

                              <th
                                scope="col"
                                className="text-uppercase tablebgtext border-top border-bottom"
                              >
                                Server Name
                              </th>
                              <th
                                scope="col"
                                className="text-uppercase tablebgtext border-top border-bottom"
                              >
                                Type
                              </th>
                              <th
                                scope="col"
                                className="text-uppercase tablebgtext border-top border-bottom"
                              >
                                Resource Group
                              </th>
                              <th
                                scope="col"
                                className="text-uppercase tablebgtext border-top border-bottom"
                              >
                                Location
                              </th>
                              {/* <th
                                scope="col"
                                className="text-uppercase tablebgtext border-top text-center border-bottom"
                              >
                                View Database
                              </th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {serverData.length > 0 ? (
                              serverData.map((data) => (
                                <tr id={data?.id} key={data?.id}>
                                  {showCheckboxes && (
                                    <td className="text-center">
                                      <input
                                        type="checkbox"
                                        checked={
                                          selectedServer?.id === data?.id
                                        }
                                        onChange={() => {
                                          if (selectedServer?.id === data?.id) {
                                            setSelectedServer(null); // Uncheck if already selected
                                          } else {
                                            setSelectedServer(data); // Check the new one
                                          }
                                        }}
                                      />
                                    </td>
                                  )}

                                  <td
                                    className="text-dark border-0 text-primary cursor-pointer"
                                    onClick={() =>
                                      handlePreview(
                                        data?.databases,
                                        data?.resourceGroup,
                                        data?.serverName,
                                        data?.serverType
                                      )
                                    }
                                  >
                                    {data?.serverName}
                                  </td>
                                  <td className="text-dark border-0">
                                    {data?.serverType}
                                  </td>
                                  <td className="text-dark border-0">
                                    {data?.resourceGroup}
                                  </td>
                                  <td className="text-dark border-0">
                                    {data?.location}
                                  </td>
                                  {/* <td className="border-0 text-center d-flex justify-content-center">
                                    <div
                                      className="btn border p-1 text-primary cursor-pointer"
                                      onClick={() =>
                                        handlePreview(
                                          data?.databases,
                                          data?.resourceGroup,
                                          data?.serverName,
                                          data?.serverType
                                        )
                                      }
                                    >
                                      <VscEye />
                                    </div>
                                  </td> */}
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan="8"
                                  className="text-center text-dark border-0"
                                >
                                  No Data Found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="w-30">
                <div className="card rounded">
                  <div className="card-header text-uppercase fw-bold">
                    Backuped Files
                  </div>
                  <div className="card-body p-3">
                    {isBlobsLoading ? (
                      <div className="d-flex justify-content-center">
                        <div className="spinner-border" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : blobs.length > 0 ? (
                      <table className="table table-alter">
                        <thead className="tablebg">
                          <tr>
                            <th>File Name</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {blobs.map((blob, idx) => (
                            <tr key={idx}>
                              <td>{blob}</td>
                              <td>
                                <div
                                  className={`btn border p-1 cursor-pointer text-center ${
                                    selectedBlob === blob
                                      ? "text-white bg-primary"
                                      : "text-primary"
                                  }`}
                                  onClick={() => {
                                    if (showCheckboxes) {
                                      setShowCheckboxes(false);
                                      setSelectedServer(null); // optional: clear selection when hiding
                                      setSelectedBlob(null);
                                    } else {
                                      setSelectedBlob(blob);
                                      setShowCheckboxes(true);
                                    }
                                  }}
                                >
                                  <LuArchiveRestore />
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <p className="text-muted">No backup files found.</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            Databases - {selectedDatabases[0]?.serverName}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedDatabases.length > 0 ? (
            <>
              {/* Start Backup button */}
              <div className="d-flex justify-content-end mb-2">
                <button
                  className="btn btn-primary backup-btn"
                  onClick={() =>                 
                    handleBulkBackup(
                      selectedDatabases.filter((db) =>
                        selectedDbIds.includes(db.name)
                      )
                    )
                  }
                  disabled={selectedDbIds.length === 0 || isBackingUp}
                >
                  <LuDatabaseBackup className="me-2" />
                  {isBackingUp ? "Backing up..." : "Start Backup"}
                </button>
              </div>
              {/* Table */}
              <div className="table-responsive">
              <table className="table table-alter">
                <thead className="tablebg">
                  <tr>
                    <th className="text-uppercase tablebgtext border-top border-bottom">Select</th>
                    <th className="text-uppercase tablebgtext border-top border-bottom">Name</th>
                    <th className="text-uppercase tablebgtext border-top border-bottom">Status</th>
                    <th className="text-uppercase tablebgtext border-top border-bottom">Size (Bytes)</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedDatabases.map((db, idx) => (
                    <tr key={idx}>
                      <td className="text-center">
                        <input
                          type="checkbox"
                          checked={selectedDbIds.includes(db.name)}
                          onChange={() => toggleDbSelection(db.name)}
                        />
                      </td>
                      <td className="text-dark border-0">{db.name}</td>
                      <td className="text-dark border-0">{db.status}</td>
                      <td className="text-dark border-0">{db.size}</td>
                    </tr>
                  ))}
                </tbody>
                </table>
              </div>{" "}
            </>
          ) : (
            <p>No databases found.</p>
          )}
        </Modal.Body>
      </Modal>

      <Modal show={showDbModal} onHide={() => setShowDbModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Select Database Name</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Select
            value={selectedDatabase}
            onChange={(e) => setSelectedDatabase(e.target.value)}
          >
            <option value="">Select a database</option>
            {selectedServer?.databases?.map((db, idx) => (
              <option key={idx} value={db.name}>
                {db.name}
              </option>
            ))}
          </Form.Select>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" onClick={handleRestore}>
            Restore
          </Button>
        </Modal.Footer>
      </Modal>

      {isBackingUp && <FullPageLoader />}
    </>
  );
};

export default DBbackup;
